import classes from "../../classes";
import FormError from "../../components/form-error";
import { Map } from "immutable";
import React from "react";
import states from "../../states";
import { withRouter } from "react-router-dom";

class CheckForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    var { history, onSubmit, session, withdraw } = this.props;
    e.preventDefault();
    onSubmit(
      session,
      withdraw.get("amount"),
      this.refs.address.value,
      this.refs.city.value,
      this.refs.state.value,
      this.refs.zip.value,
      history
    );
  }

  render() {
    var { communications, session } = this.props;
    var stateElems = states.map(state => (
      <option key={state.abbr} value={state.abbr}>
        {state.name}
      </option>
    ));
    var billingAddress = session.get("billing_address");

    var loading = communications.getIn(["check_withdraw", "state"]) === "in progress";
    var errors = communications.getIn(["check_withdraw", "error"]) || Map();

    return (
      <form className="form--is-horizontal display--fade-in" data-target="panel-check" onSubmit={this.onSubmit}>
        <div className="batch-g batch-g--padding batch-g--valign-center">
          <div className="batch-c-1-1 batch-c-md-1-4 text-right" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <h3>
              Mail check to:
            </h3>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="address">
              Address
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" defaultValue={billingAddress.get("address")} id="address" name="address" placeholder="Address" ref="address" type="text" />

            <FormError error={errors.get("address")} name="Address" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="city">
              City
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" defaultValue={billingAddress.get("city")} id="city" name="city" placeholder="City" ref="city" type="text" />

            <FormError error={errors.get("city")} name="City" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="state-zip">
              State/ZIP
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="batch-g">
              <div className="batch-c-1-2 padding-right--is-10">
                <div className="form_input form_input--select form_input--is-block">
                  <select defaultValue={billingAddress.get("state") || "Select State"} ref="state">
                    <option disabled>
                      Select State
                    </option>

                    {stateElems}
                  </select>
                </div>

                <FormError error={errors.get("state")} name="State" />
              </div>

              <div className="batch-c-1-2">
                <input className="form_input" defaultValue={billingAddress.get("zip_code")} id="zip-code" name="zip-code" placeholder="ZIP Code" ref="zip" type="text" />

                <FormError error={errors.get("zip_code")} name="ZIP Code" />
              </div>
            </div>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="form_action">
              <input
                className={classes({
                  "btn": true,
                  "btn--primary": true,
                  "btn--is-loading": loading,
                })}
                disabled={loading}
                type="submit"
                value={loading ? "Processing" : "Payout Via Check"} />
            </div>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <p className="note-text">
              Payouts will be received in 7 to 10 business days.
            </p>
          </div>
        </div>
      </form>
    );
  }
}

export default withRouter(CheckForm);
